import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AssumptionsModule } from '@components/assumptions/assumptions.module';
import { DialogAddScenarioComponent } from '@components/model-structure/scenarios/add-scenario-dialog/add-scenario-dialog';
import { CoreModule } from '@core/core.module';
import { LoaderModule } from '@core/loader/loader.module';
import { MaterialModule } from '@core/material.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { SharedModule } from '@shared/shared.module';
import { ScenarioTableComponent } from './scenario-table/scenario-table.component';
// import { PaginationModule } from 'ngx-bootstrap/pagination';

const routes: Routes = [
  {
    path: '',
    component: ScenarioTableComponent,
    outlet: 'structure-outlet',
  },
];

@NgModule({
  imports: [
    CoreModule,
    AssumptionsModule,
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forChild(routes),
    // PaginationModule.forRoot(),
    SharedModule,
    SpreadSheetsModule,
    WindowModule,
    LoaderModule,
  ],
  declarations: [DialogAddScenarioComponent, ScenarioTableComponent],
  exports: [RouterModule, FormsModule, ReactiveFormsModule],
})
export class ScenariosModule {}
